import * as React from 'react';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';

export default function PieChartWithCustomizedLabel(props) {
  const StatusTruePre = (props.StatuesTrue / 18) * 100;
  const StatusCorrectPre = (props.StatusCorrect / 18) * 100;
  const StatusFalsePre = (props.StatusFalse / 18) * 100;

  // Data for the PieChart
  const data = [
    { label: 'Group A', value: StatusTruePre, color: "#27ae60" },
    { label: 'Group B', value: StatusCorrectPre, color: "#f39c12" },
    { label: 'Group C', value: StatusFalsePre, color: "#e74b3b" },
  ];

  // Total value for calculating percentages
  const TOTAL = data.map((item) => item.value).reduce((a, b) => a + b, 0);

  // Function to get the arc label
  const getArcLabel = (params) => {
    const percent = params.value / TOTAL;
    return `${(percent * 100).toFixed(0)}%`;
  };

  // Styling and sizing for the PieChart
  const sizing = {
    margin: { right: 5 },
    width: 200,
    height: 200,
    legend: { hidden: true },
  };

  return (
    <div id={`section-${props.index}`}>
      <PieChart
        series={[
          {
            outerRadius: 80,
            data,
            arcLabel: getArcLabel,
          },
        ]}
        sx={{
          [`& .${pieArcLabelClasses.root}`]: {
            fill: 'white',
            fontSize: 14,
          },
        }}
        {...sizing}
      />
    </div>
  );
}
